import React from 'react'
import LandingContainer from '../containers/Landing/Landing.container'

const Landing = () => {
  return <LandingContainer />
}

export default Landing
